module.exports = "<my-title my-label=\"'Les wagons ont bien été ferraillés'\"\n  my-style=\"$root.styles.titles.center\"\n  my-level=\"3\">\n</my-title>\n\n<div class=\"section center\">\n  <my-button my-label=\"$root.labels.wagon.statements.newManeuver\"\n    my-icon=\"$root.icons.back\"\n    my-style=\"$root.styles.dark()\"\n    my-click=\"goToSelectWagons()\">\n  </my-button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/maneuver/scrap/templates/report.html
// module id = 1600
// module chunks = 0